import { NotificationTriggeredByTypeEnum } from '@umss/shared/utils';

export enum NotificationType {
  Corporate = 'Corporate',
  Shift = 'Shift',
  Facility = 'Facility',
  System = 'System',
  Reminder = 'Reminder',
  UrgentShift = 'UrgentShift',
  Payment = 'Payment'
}

export interface NotificationAction {
  id: number;
  actionType: string;
  actionLabel: string;
  actionUrl?: string;
  isPrimary: boolean;
}

export interface Notification {
  id: string;
  recipientId: string;
  notificationType: NotificationType;
  notificationTypeDisplay: string;
  title: string;
  body: string;
  isRead: boolean;
  actionRequired: boolean;
  createdAt: string;
  readAt?: string;
  senderName?: string;
  actions: NotificationAction[];
  triggeredBy?: NotificationTriggeredBy;
}

export interface NotificationTriggeredBy {
  id: string;
  type: NotificationTriggeredByTypeEnum;
  shiftNeedId?: string | null;
}
